import(/* webpackMode: "eager" */ "/vercel/path0/app/sirs/page.tsx");
